const CampaignHeader = ({ campaignData }) => {
  const dateStr = campaignData?.createdAt;
  const date = new Date(dateStr);

  const options = { day: "2-digit", month: "long", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-GB", options);

  return (
    <div className="campaign_header position-relative">
      <div className="d-flex align-items-center">
        <div className="campaign_logo">
          {campaignData?.campaignLogo == null ? (
            <p>{campaignData?.campaignName?.slice(0, 1)?.toUpperCase()}</p>
          ) : (
            <img
              src={campaignData?.campaignLogo}
              alt={`${campaignData?.campaignName} logo`}
            />
          )}
        </div>
        <div className="ms-2">
          <h2 className="campaign_name">{campaignData?.campaignName}</h2>
          <p className="light_text">
            Created on <span>{formattedDate}</span>
          </p>
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div className="status">
          <span>Status </span>
          {campaignData?.campaignStatus?.toLowerCase() === "active" && (
            <span className="chip">{campaignData?.campaignStatus}</span>
          )}
          {campaignData?.campaignStatus?.toLowerCase() ===
            "not started yet" && (
            <span className="notStarted_chip chip">
              {campaignData?.campaignStatus}
            </span>
          )}
          {campaignData?.campaignStatus?.toLowerCase() === "on hold" && (
            <span className="onHold_chip chip">
              {campaignData?.campaignStatus}
            </span>
          )}
          {campaignData?.campaignStatus?.toLowerCase() === "completed" && (
            <span className="completed_chip chip">
              {campaignData?.campaignStatus}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampaignHeader;
